import { Edges } from "@react-three/drei";
import * as THREE from "three";
import { colors } from "../../utils/colors";

export default function FilledPolygon({
  verts,
  opacity = 0.5,
  color = "red",
  ...props
}) {
  if (!verts?.length) return null;
  const normal = new THREE.Vector3();
  const a = new THREE.Vector3().fromArray(verts[0]);
  const b = new THREE.Vector3().fromArray(verts[1]);
  const c = new THREE.Vector3().fromArray(verts[2]);
  normal.crossVectors(b.clone().sub(a), c.clone().sub(a)).normalize();

  const xAxis = new THREE.Vector3(1, 0, 0);
  if (Math.abs(normal.dot(xAxis)) > 0.9) xAxis.set(0, 1, 0);
  const u = new THREE.Vector3().crossVectors(normal, xAxis).normalize();
  const v = new THREE.Vector3().crossVectors(normal, u).normalize();

  const projected = verts.map(([x, y, z]) => {
    const p = new THREE.Vector3(x, y, z);
    return [p.dot(u), p.dot(v)];
  });

  const projectedVec2 = projected.map(([x, y]) => new THREE.Vector2(x, y));
  const indices = THREE.ShapeUtils.triangulateShape(projectedVec2, []);

  const geom = new THREE.BufferGeometry();
  const pos = [];
  indices.forEach(([i0, i1, i2]) => {
    [i0, i1, i2].forEach((i) => {
      pos.push(...verts[i]);
    });
  });

  geom.setAttribute("position", new THREE.Float32BufferAttribute(pos, 3));
  geom.computeVertexNormals();

  return (
    <mesh geometry={geom} rotation-x={Math.PI * -0.5} {...props}>
      <meshStandardMaterial
        color={color}
        side={THREE.DoubleSide}
        transparent
        opacity={opacity}
      />
      <Edges color={colors.gray400()} />
    </mesh>
  );
}

export function LineSegments({ verts, lineRef, color = "#f00", ...props }) {
  let vertices = verts;
  let geometry;

  if (!vertices && lineRef?.current) {
    const position = lineRef.current?.geometry?.attributes?.position?.array;

    vertices = [
      [position?.[0], position?.[1], position?.[2]],
      [position?.[3], position?.[4], position?.[5]],
    ];
  }

  if (vertices)
    geometry = new THREE.BufferGeometry().setFromPoints(
      vertices?.map((point) => new THREE.Vector3(...point))
    );

  return (
    <line ref={lineRef} geometry={geometry} {...props}>
      <lineBasicMaterial color={color} />
    </line>
  );
}
